export default __webpack_public_path__ + "static/media/LifeRamp.42773651.png";